<template>
  <CommonOverlay class="overlay" @handleOverlayClick="handleOverlayClick">
    <CommonModal class="modal">
      <div class="user-register">
        <div class="row_area">
          <div class="input-area">
            <div class="flex">
              <div class="address_area">
                <v-text-field
                  :label="t('姓')"
                  outlined
                  v-model="lastName"
                  hide-details="auto"
                ></v-text-field>
                <ErrorMessage
                  v-if="errorMessageLastName"
                  class="error-message"
                  :message="errorMessageLastName"
                />
              </div>
              <!-- 日本固定のためミドルネーム非表示
              <div class="address_area">
                <v-text-field
                v-if="currentUserDetail.country_id !== '84'"
                :label="t('ミドルネーム')"
                outlined
                v-model="middleName"
                hide-details="auto"
                ></v-text-field>
                <ErrorMessage
                v-if="errorMessageMiddleName"
                class="error-message"
                :message="errorMessageMiddleName"
                />
              </div>
              -->
              <div class="address_area">
                <v-text-field
                  :label="t('名')"
                  outlined
                  v-model="firstName"
                  hide-details="auto"
                ></v-text-field>
                <ErrorMessage
                  v-if="errorMessageFirstName"
                  class="error-message"
                  :message="errorMessageFirstName"
                />
              </div>
            </div>
            <!-- 国設定は日本固定のため非表示
            <div class="address_area">
              <v-select
                v-if="countryList"
                :label="t('国')"
                outlined
                :items="countryList"
                item-text="name"
                item-value="id"
                v-model="countryId"
                hide-details="auto"
                prepend-inner-icon="mdi-earth"
              ></v-select>
              <ErrorMessage
                v-if="errorMessageCountryId"
                class="error-message"
                :message="errorMessageCountryId"
              />
            </div>
            -->
            <div class="address_area">
              <v-text-field
                :label="t('郵便番号')"
                prepend-inner-icon="mdi-map-marker"
                outlined
                v-model="zipCode"
                hide-details="auto"
                @change="inputAddress"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageZipCode"
                class="error-message"
                :message="errorMessageZipCode"
              />
            </div>

            <div v-if="prefectureList && countryId === '84'" class="address_area">
              <v-select
                :label="t('都道府県')"
                outlined
                :items="prefectureList"
                item-text="name"
                item-value="id"
                v-model="prefectureId"
                hide-details="auto"
                prepend-inner-icon="mdi-map-marker"
              ></v-select>
              <ErrorMessage
                v-if="errorMessagePrefectureId"
                class="error-message"
                :message="errorMessagePrefectureId"
              />
            </div>
            <!-- 日本固定のため州フィールド非表示
            <div v-if="countryId !== '84'" class="address_area">
              <v-text-field
                :label="t('州')"
                prepend-inner-icon="mdi-map-marker"
                outlined
                v-model="province"
                hide-details="auto"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageProvince"
                class="error-message"
                :message="errorMessageProvince"
              />
            </div>
            -->

            <div class="address_area">
              <v-text-field
                :label="t('市区町村')"
                prepend-inner-icon="mdi-map-marker"
                outlined
                v-model="shiku"
                hide-details="auto"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageShiku"
                class="error-message"
                :message="errorMessageShiku"
              />
            </div>

            <div class="address_area">
              <v-text-field
                :label="t('住所1')"
                prepend-inner-icon="mdi-map-marker"
                outlined
                v-model="address"
                hide-details="auto"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageAddress"
                class="error-message"
                :message="errorMessageAddress"
              />
            </div>

            <div class="address_area">
              <v-text-field
                :label="t('住所2')"
                prepend-inner-icon="mdi-map-marker"
                outlined
                v-model="building"
                hide-details="auto"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageBuilding"
                class="error-message"
                :message="errorMessageBuilding"
              />
            </div>

            <div class="address_area">
              <v-text-field
                :label="t('電話番号')"
                prepend-inner-icon="mdi-phone"
                outlined
                v-model="tel"
                hide-details="auto"
              ></v-text-field>
              <ErrorMessage
                v-if="errorMessageTel"
                class="error-message"
                :message="errorMessageTel"
              />
            </div>
            <div class="button-area">
              <BuyButton
                class="square-button purchase-btn"
                :text="t('登録')"
                :isArrow="false"
                @handleSquareBtnClick="register"
              />
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  </CommonOverlay>
</template>

<script>
import { mapGetters } from 'vuex';
import t from '@/plugins/i18n';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import BuyButton from '@/components/atoms/BuyButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';

export default {
  name: 'AddressPopup',
  mixins: [t],

  components: {
    CommonOverlay,
    CommonModal,
    BuyButton,
    ErrorMessage,
  },

  data: () => ({
    countryId: '84',
    tel: '',
    zipCode: '',
    country: '',
    prefectureId: '',
    shiku: '',
    address: '',
    province: '',
    building: '',
    errorMessageCountryId: '',
    errorMessageTel: '',
    errorMessageZipCode: '',
    errorMessagePrefectureId: '',
    errorMessageShiku: '',
    errorMessageAddress: '',
    errorMessageBuilding: '',
    errorMessageProvince: '',
    lastName: '',
    firstName: '',
    middleName: '',
    errorMessageLastName: '',
    errorMessageFirstName: '',
    errorMessageMiddleName: '',
  }),

  created() {
    this.$store.dispatch('country/setCountryList');
    this.$store.dispatch('prefecture/setPrefectureList');
  },

  computed: {
    ...mapGetters({
      currentUserDetail: 'user/currentUserDetail',
      countryList: 'country/countryList',
      prefectureList: 'prefecture/prefectureList',
      changeUserAddressResult: 'user/changeUserAddressResult',
      currentAddress: 'zipCode/currentAddress',
    }),
    userDefaults() {
      if (!this.currentUserDetail) return {};
      return {
        countryId: String(this.currentUserDetail.country_id ?? '84'),
        tel: this.currentUserDetail.tel ?? '',
        zipCode: this.currentUserDetail.zipcode ?? '',
        country: this.currentUserDetail.country ?? '',
        prefectureId: this.currentUserDetail.pref_id ?? '',
        shiku: this.currentUserDetail.shiku ?? '',
        address: this.currentUserDetail.address ?? '',
        province: this.currentUserDetail.province ?? '',
        building: this.currentUserDetail.building ?? '',
        lastName: this.currentUserDetail.lastName ?? '',
        firstName: this.currentUserDetail.firstName ?? '',
        middleName: this.currentUserDetail.middleName ?? '',
      };
    },
  },

  watch: {
    currentUserDetail(newVal) {
      if (newVal) {
        Object.assign(this.$data, this.userDefaults);
      }
    },
    changeUserAddressResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearChangeUserInformationResult');
          this.$store.dispatch('pack/setBuyPackResult');
          this.$emit('handleSuccess');
        } else {
          const {
            tel,
            zipcode,
            pref_id: prefId,
            shiku,
            address,
            building,
            country_id: countryId,
            province,
            lastName,
            firstName,
            middleName,
          } = newVal.errors;
          this.errorMessageCountryId = countryId ? countryId[0] : null;
          this.errorMessageTel = tel ? tel[0] : null;
          this.errorMessageZipCode = zipcode ? zipcode[0] : null;
          this.errorMessagePrefectureId = prefId ? prefId[0] : null;
          this.errorMessageShiku = shiku ? shiku[0] : null;
          this.errorMessageAddress = address ? address[0] : null;
          this.errorMessageBuilding = building ? building[0] : null;
          this.errorMessageProvince = province ? province[0] : null;
          this.errorMessageLastName = lastName ? lastName[0] : null;
          this.errorMessageFirstName = firstName ? firstName[0] : null;
          this.errorMessageMiddleName = middleName ? middleName[0] : null;
        }
      }
    },
    currentAddress(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          const { result } = newVal;
          this.prefectureId = result[0].prefcode;
          this.shiku = `${result[0].address2}${result[0].address3}`;
          this.province = result[0].province;
        }
      }
    },
  },

  methods: {
    register() {
      if (this.prefectureId === 99) {
        this.prefectureId = '';
      }
      if (this.countryId !== '84') {
        this.prefectureId = 99;
      }
      const postParams = {
        tel: this.tel,
        zipcode: this.zipCode,
        country: this.country,
        province: this.province,
        pref_id: this.prefectureId,
        shiku: this.shiku,
        address: this.address,
        building: this.building,
        country_id: '84', // 日本固定
        lastName: this.lastName,
        firstName: this.firstName,
        middleName: this.middleName,
      };
      this.$store.dispatch('user/changeUserAddress', { postParams });
    },
    inputAddress() {
      if (this.countryId === '84') {
        const zipCodeLength = 7;
        if (String(this.zipCode).length === zipCodeLength) {
          const postParams = {
            zipcode: this.zipCode,
          };
          this.$store.dispatch('zipCode/setCurrentAddress', { postParams });
        }
      }
    },
    handleOverlayClick(event) {
      // 自分自身がクリックされたときだけ emit
      if (event.target === event.currentTarget) {
        this.$emit('handleClose');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    width: auto;
    padding: 20px;
    width: 600px;
    max-height: 100%;
    overflow-y: auto;
  }
}
.user-register {
  position: relative;
  width: 100%;
  max-width: 800px;
  min-height: 100%;
  padding: 20px 20px;
  margin: 0px auto;
  background-color: #fff;
  border-radius: 36px;
  border-top-right-radius: 0;
  color: $baseColor;
  @media screen and (max-width: $tabletWidth) {
    padding: 30px 20px 20px;
    width: 96%;
  }
  .error {
    background-color: rgba(0, 0, 0, 0) !important;
    color: $red;
    margin-bottom: 10px;
    text-align: center;
  }
}
.button-area {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  .purchase-btn {
    width: 48%;
    border-radius: initial;
  }
}
.flex{
  display: flex;
  justify-content: space-between;
  gap:5px;
}
.address_area {
  margin-top: 20px;
}
@media screen and (max-width: $tabletWidth) {
  .overlay {
    .modal {
      width: 100%;
    }
  }
}
</style>
